export const filterOptions = (options, query) => {
  const q = query.trim().toLowerCase();
  if (!q) return options;
  return options.filter((opt) => {
    const label = String(opt.label ?? "").toLowerCase();
    if (label.includes(q)) return true;
    const keywords = opt.keywords;
    if (Array.isArray(keywords)) {
      return keywords.some((k) => String(k).toLowerCase().includes(q));
    }
    return false;
  });
};
